import {
  Component, ChangeDetectionStrategy, Output, 
  EventEmitter, Input, ElementRef, OnChanges, SimpleChanges, ChangeDetectorRef
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, of } from 'rxjs';

import { isEmpty } from '@app/util/util';
import {
  ChipFilterActionType, ChipFilterSize, ChipFilterState
} from '@design-system/components/molecules/chip-filter/entities/chip-filter.types';

@Component({
  selector: 'app-filter-bar-tag',
  templateUrl: './filter-bar-tag.component.html',
  styleUrls: ['./filter-bar-tag.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FilterBarTagComponent implements OnChanges {

  @Input() label: string;
  @Input() icon: string;
  @Input() isMultipleSelection: boolean;
  @Input() isActive: boolean;
  @Input() toTranslate: boolean;
  @Input() isSpecialIcon = false;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public elRefClass = '';

  public readonly chipFilterSize = ChipFilterSize.SM;

  constructor(
    private readonly translateService: TranslocoService,
    private readonly elRef: ElementRef,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isEmpty(changes?.isActive)) {
      this.elRefClass = this.elRef?.nativeElement?.className;
      this.cdr.detectChanges();
    }
  }

  get label$(): Observable<string> {
    return this.toTranslate ? this.translateService.selectTranslate(this.label) : of(this.label);
  }

  get chipActionType(): ChipFilterActionType {
    return this.isMultipleSelection ? ChipFilterActionType.Dropdown : 
      this.isActive ? ChipFilterActionType.Removable : ChipFilterActionType.Tag;
  }

  get chipFilterState(): ChipFilterState {
    return this.isActive ? ChipFilterState.Highlight : ChipFilterState.Default;
  }

}
